<template lang="pug">
  div.car-park.cars
    e-toolbar(
      :items="items"
      @deleteItems="deleteItems"
      :hideRemoveButton="true"
      :showTotal="true"
      :showViewPanel="false"
      :hideImportBtn="true"
      :hideAddButton="true"
    )
    e-table(
      :items="items"
      @deleteItem="deleteItem"
      @editItem="() => ({})"
      :showCheckbox="false"
      :showDeleteButton="showDeleteButton"
      :showEditButton="false"
    )

    router-view
</template>

<script>
  import {transport} from '../../api/api-endpoints.js'
  import tableMixin from '../../components/table/table-mixin.js'
  import {SHOW_HIDDEN_FIELDS} from "../../config/config"

  export default {
    mixins: [tableMixin],
    computed: {
      showDeleteButton () {
        return SHOW_HIDDEN_FIELDS
      }
    },
    methods: {
      getEndpoint (route) {
        return transport.park(route)
      },
      getDeleteUrl (id) {
        if (!this.showDeleteButton) {
          return null
        }
        return transport.car(id)
      }
    }
  }
</script>
